/*  ========================================================================
    # Component - Job Filter
    ========================================================================  */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const JobFilter = ({ label, defaultOptionText, filter, selectedOption, onChange }) => {
  const selectRef = useRef(null);

  const handleOptionChange = option => {
    onChange(option);
  };

  return (
    <div className='s-jobs__filter'>
      {label && <label className='s-jobs__filter-label'>{label}</label>}
      <select
        className='s-jobs__filter-select'
        value={selectedOption}
        onChange={e => handleOptionChange(e.target.value)}
        ref={selectRef}
      >
        <option value=''>{defaultOptionText}</option>
        {filter && filter.map(option => (
          <option key={option.slug} value={option.slug}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

JobFilter.propTypes = {
  label: PropTypes.string,
  defaultOptionText: PropTypes.string,
  filter: PropTypes.array,
  selectedOption: PropTypes.string,
  onChange: PropTypes.func
};

export default JobFilter;
